var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"emoji"},[(_vm.value.startsWith('/'))?_c('img',{staticClass:"emoji_icon",attrs:{"src":("/img/emoji" + _vm.value)}}):_c('span',{staticClass:"emoji_icon"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }